module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_25.4ccff43d.pdf";